module.exports = [
  {
    name: "clicker",
    displayName: "Clicker",
    ogcost: 10,
    cps: 1,

    cost: 0,
    amount: 0,
  },
  {
    name: "grandma",
    displayName: "Grandma",
    ogcost: 50,
    cps: 6,

    cost: 0,
    amount: 0,
  },
  {
    name: "farm",
    displayName: "Farm",
    ogcost: 100,
    cps: 15,

    cost: 0,
    amount: 0,
  },
  {
    name: "factory",
    displayName: "Factory",
    ogcost: 250,
    cps: 40,

    cost: 0,
    amount: 0,
  },
  {
    name: "gigafactory",
    displayName: "GigaFactory",
    ogcost: 1000,
    cps: 200,

    cost: 0,
    amount: 0,
  },
  {
    name: "clonemachine",
    displayName: "Clone Machine",
    ogcost: 25000,
    cps: 6500,

    cost: 0,
    amount: 0,
  },
  {
    name: "portal",
    displayName: "Portal",
    ogcost: 1_000_000,
    cps: 300_000,

    cost: 0,
    amount: 0,
  },
  {
    name: "universe",
    displayName: "Cupcake Universe",
    ogcost: 50_000_000,
    cps: 15_000_000,

    cost: 0,
    amount: 0,
  },
  {
    name: "universegenerator",
    displayName: "Universe Generator",
    ogcost: 5_000_000_000,
    cps: 1_500_000_000,

    cost: 0,
    amount: 0,
  },
  {
    name: "particleconverter",
    displayName: "Particle Converter",
    ogcost: 10_000_000_000_000,
    cps: 3_000_000_000_000,

    cost: 0,
    amount: 0,
  },
  {
    name: "quantumgenerator",
    displayName: "Quantum Generator",
    ogcost: 20_000_000_000_000_000,
    cps: 6_000_000_000_000_000,

    cost: 0,
    amount: 0,
  },
  {
    name: "quantumgeneratorfarm",
    displayName: "Quantum Generator Farm",
    ogcost: 40_000_000_000_000_000_000,
    cps: 12_000_000_000_000_000_000,

    cost: 0,
    amount: 0,
  },
  {
    name: "fryingpan",
    displayName: "Frying pan",
    ogcost: 100_000_000_000_000_000_000_000,
    cps: 30_000_000_000_000_000_000_000,

    cost: 0,
    amount: 0,
  },
];
